export const messages = {
  en: {
    devServiceProvide: {
      prevStep: 'Previous',
      nextStep: 'Next',
      finish: 'Finish',
      requiredInfo: 'Please fill in the required information',
      success: 'Operation successful',
      error: 'Operation failed'
    },
    viewServiceInfo: {
      title: 'Service Information',
      selectService: 'Select Service',
      addService: 'Add Service',
      serviceId: 'Service ID',
      serviceName: 'Service Name',
      serviceCode: 'Service Code',
      messageQueue: 'Message Queue',
      isInstance: 'Is Instance',
      invokeUrl: 'Invoke URL',
      invokeMethod: 'Invoke Method',
      timeout: 'Timeout',
      retryCount: 'Retry Count'
    },
    
    chooseService: {
      title: 'Select Service',
      searchPlaceholder: 'Enter service name',
      serviceName: 'Service Name',
      serviceCode: 'Service Code',
      invokeMethod: 'Invoke Method',
      operation: 'Operation',
      select: 'Select',
      queryError: 'Query failed'
    },
    devServiceProvideView: {
      title: 'Develop Service Implementation',
      implementType: 'Implementation Type',
      implementTypePlaceholder: 'Required, please select implementation type',
      sqlMethod: 'SQL Method',
      javaMethod: 'Java Method',
      procedureMethod: 'Procedure Method',
      params: 'Parameters',
      paramsPlaceholder: 'Required, please enter parameters',
      sql: 'SQL',
      sqlPlaceholder: 'Optional, please enter SQL',
      outputTemplate: 'Output Template',
      outputTemplatePlaceholder: 'Optional, please enter output template',
      procedure: 'Procedure',
      procedurePlaceholder: 'Optional, please enter procedure',
      javaCode: 'Java Code',
      javaCodePlaceholder: 'Optional, please enter Java code'
    },
    serviceProvideRemarkView: {
      title: 'Service Provide Remark',
      description: 'Description',
      descriptionPlaceholder: 'Optional, please enter description'
    }
  },
  zh: {
    devServiceProvide: {
      prevStep: '上一步',
      nextStep: '下一步',
      finish: '完成',
      requiredInfo: '请填写必选信息',
      success: '操作成功',
      error: '操作失败'
    },
    viewServiceInfo: {
      title: '服务信息',
      selectService: '选择服务',
      addService: '添加服务',
      serviceId: '服务ID',
      serviceName: '服务名称',
      serviceCode: '服务编码',
      messageQueue: '消息队列',
      isInstance: '是否实例',
      invokeUrl: '调用地址',
      invokeMethod: '调用方式',
      timeout: '超时时间',
      retryCount: '重试次数'
    },
    
    chooseService: {
      title: '选择服务',
      searchPlaceholder: '输入服务名称',
      serviceName: '服务名称',
      serviceCode: '服务编码',
      invokeMethod: '调用方式',
      operation: '操作',
      select: '选择',
      queryError: '查询失败'
    },
    devServiceProvideView: {
      title: '开发服务实现',
      implementType: '实现方式',
      implementTypePlaceholder: '必填，请选择实现方式',
      sqlMethod: 'sql方式',
      javaMethod: 'java方式',
      procedureMethod: '存储过程方式',
      params: '参数',
      paramsPlaceholder: '必填，请填写参数',
      sql: 'sql',
      sqlPlaceholder: '选填，请填写sql',
      outputTemplate: '输出模板',
      outputTemplatePlaceholder: '选填，请填写输出模板',
      procedure: '存储过程',
      procedurePlaceholder: '选填，请填写存储过程',
      javaCode: 'java代码',
      javaCodePlaceholder: '选填，请填写java代码'
    },
    serviceProvideRemarkView: {
      title: '开发服务提供',
      description: '描述',
      descriptionPlaceholder: '选填，请填写描述'
    }
  }
}